export const GET_ORDER_STATUS_REQUEST = 'GET_ORDER_STATUS_REQUEST';
export const GET_ORDER_STATUS_DATA = 'GET_ORDER_STATUS_DATA';
export const GET_ORDER_STATUS_ERROR = 'GET_ORDER_STATUS_ERROR';

export const SET_ORDER_HISTORY_SORT_DATA = 'SET_ORDER_HISTORY_SORT_DATA';
export const SORTING_ORDER_HISTORY_ACTION = 'SORTING_ORDER_HISTORY_ACTION';

export const CREATE_ORDER_STATUS_REQUEST = 'CREATE_ORDER_STATUS_REQUEST';
export const CREATE_ORDER_STATUS_DATA = 'CREATE_ORDER_STATUS_DATA';
export const CREATE_ORDER_STATUS_ERROR = 'CREATE_ORDER_STATUS_ERROR';

export const UPDATE_ORDER_STATUS_REQUEST = 'UPDATE_ORDER_STATUS_REQUEST';
export const UPDATE_ORDER_STATUS_DATA = 'UPDATE_ORDER_STATUS_DATA';
export const UPDATE_ORDER_STATUS_ERROR = 'UPDATE_ORDER_STATUS_ERROR';

export const DELETE_ORDER_STATUS_REQUEST = 'DELETE_ORDER_STATUS_REQUEST';
export const DELETE_ORDER_STATUS_DATA = 'DELETE_ORDER_STATUS_DATA';
export const DELETE_ORDER_STATUS_ERROR = 'DELETE_ORDER_STATUS_ERROR';